/* Copyright (c) 2017 Backpack Health LLC */

import { PropTypes } from 'prop-types';

const colorBlue = '#007AFF';
// const colorRedDark = '#E20D0D';
const colorRedLight = '#FD3235';
const colorGreen = '#2BC552';
// const colorOrange = '#FDA732';
// const colorPurple = '#8A2BE2';
// const colorBlueDark = '#2C70BB';

const grayscaleDarkest = '#111111';
const grayscaleDark = '#414141';
const grayscaleMedDark = '#646464';
const grayscaleMiddle = '#9E9E9E';
const grayscaleMedLight = '#BFBFBF';
const grayscaleLight = '#E7E7E7';
const grayscaleLightest = '#FFFFFF';

const grayscaleLighterYet = '#F3F3F3';
// const colorBrandPrimary = '#E20D0D';
// const colorBrandSecondary = '#FFFFFF';

const disabledOverlayProfileColor = 'rgba(0, 0, 0, 0.15)';
const enabledOverlayProfileColor = 'rgba(0, 0, 0, 0.5)';
const darkOverlayColor = 'rgba(17, 17, 17, 0.3)';
const gsMiddleLT = 'rgba(255, 255, 255, 0.65)';
const gsMiddleDT = 'rgba(17, 17, 17, 0.4)';
const bcBackpackRedBase = 'rgba(216, 27, 81, 1)';
const bcBackpackRedAccent = 'rgba(160, 0, 41, 1)';
const bcBackpackRedHighlight = 'rgba(255, 92, 125, 1.00)';
const csAppBGgray30 = 'rgba(243, 243, 243, 0.3)';
const systemRed = '#E10C0C';
const brandDarkAccent = 'rgba(160, 0, 41, 1)';
const csHotRed = '#F3082D';

const dtDarkMiddle = 'rgba(17, 17, 17, 0.4)';
const gsDarkDT = 'rgba(17, 17, 17, 0.8)';
const gsMedDarkLT = 'rgba(255, 255, 255, 0.40)';

const COLORS = {
  navDefault: grayscaleLightest,
  navFooterDefault: colorBlue,
  navDisabled: grayscaleMiddle,
  iconBlue: colorBlue,
  iconRed: colorRedLight,
  iconGreen: colorGreen,
  whiteText: grayscaleLightest,
  darkText: grayscaleDarkest,
  disabledOverlayProfileColor,
  enabledOverlayProfileColor,
  darkOverlayColor,
  middleGray: '#A0A0A0',
  black: '#000',

  bcBackpackRedBase,
  bcBackpackRedAccent,
  bcBackpackRedHighlight,

  brandDarkAccent,

  grayscaleLighterYet,
  gsLightest: grayscaleLightest,
  gsLight: grayscaleLight,
  gsMedLight: grayscaleMedLight,
  gsMiddleLT,
  gsMiddleDT,
  gsMiddle: grayscaleMiddle,
  gsMedDark: grayscaleMedDark,
  gsDark: grayscaleDark,
  gsDarkest: grayscaleDarkest,

  dtDarkMiddle,
  gsDarkDT,
  gsMedDarkLT,

  white: grayscaleLightest,
  grayBackground: grayscaleLighterYet,

  healthEntryPropertyIconWithValue: grayscaleDarkest,
  healthEntryPropertyIconEmpty: grayscaleMedDark,
  healthEntryPropertyWithValue: grayscaleDarkest,
  healthEntryPropertyEmpty: grayscaleDark,
  csAppBGgray30,
  csHotRed,
  systemRed,
};

const colorNameList = [
  'profile',
  'profile-highlight',
  'profile-accent',
  'inactive',
  'white',
  'black',
  'light-neutral',
  'neutral',
  'dark-neutral',
  'middle-gray',
  'transparent',
  'security',
  'not-found',
  'gsMedDark',
  'gsMiddleLT',
  'gsMiddle',
  'gsDarkest',
  'white',
];

export const colorClassNames = {
  nameProp: PropTypes.oneOf(colorNameList),

  font(colorName) {
    return `font-color-${colorName}`;
  },

  fill(colorName) {
    return `fill-color-${colorName}`;
  },

  stroke(colorName) {
    return `stroke-color-${colorName}`;
  },

  border(colorName) {
    return `border-color-${colorName}`;
  },

  background(colorName) {
    return `bkgd-color-${colorName}`;
  },

};

export function getFontColorClassNameOLD(colorName) {
  switch (colorName) {
    case 'white':
      return 'font-color-input-white';
    case 'profile':
      return 'font-color-profile';
    case 'error':
      return 'font-color-input-error';
    case 'active':
      return 'font-color-input-active';
    case 'inactive':
      return 'font-color-input-inactive';
    case 'neutral':
      return 'font-color-neutral';
    case 'light':
      return 'font-color-light';
    case 'middle-gray':
      return 'font-color-middle-gray';
    case 'dark-neutral':
      return 'font-color-dark-neutral';
    case 'darkest-gray':
      return 'font-color-darkest-gray';
    case 'medDarkGray':
      return 'font-color-meddark-gray';
    case 'gsMedDark':
      return 'font-color-gsMedDark';
    case 'gsDark':
      return 'font-color-gsDark';
    case 'light-neutral':
      return 'font-color-light-neutral';
    default:
      return '';
  }
}
export default COLORS;
